import { Outlet, Navigate } from "react-router-dom";
import { useMaterialUIController } from "context";

export const PublicRoute = ({ children, redirectTo = "/dashboard" }) => {
  const accessToken = localStorage.getItem('accessToken');

  if (accessToken) {
    return <Navigate to={redirectTo} />
  }

  return children;
}

